// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container-DK6zz {
  height: 44px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  background-color: white;
  border-bottom: 1px solid var(--border-color);
  padding: 0px 20px;
}

.header-logo-NixKN {
  width: 24px;
  height: 24px;
  margin-right: 20px;
}

.header-title-RUGRU {
  font-size: 16px;
  font-weight: 500;
}

.header-user-lYune {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: auto;
}

.header-name-aobFc {
  font-size: 14px;
  font-weight: 500;
  margin-right: 12px;
}

.header-icon-RnNey {
  --size: 18px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/header/header.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".container {\n  height: 44px;\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  background-color: white;\n  border-bottom: 1px solid var(--border-color);\n  padding: 0px 20px;\n}\n\n.logo {\n  width: 24px;\n  height: 24px;\n  margin-right: 20px;\n}\n\n.title {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.user {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  margin-left: auto;\n}\n\n.name {\n  font-size: 14px;\n  font-weight: 500;\n  margin-right: 12px;\n}\n\n.icon {\n  --size: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `header-container-DK6zz`,
	"logo": `header-logo-NixKN`,
	"title": `header-title-RUGRU`,
	"user": `header-user-lYune`,
	"name": `header-name-aobFc`,
	"icon": `header-icon-RnNey`
};
export default ___CSS_LOADER_EXPORT___;
